import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DelegoSilentPaymentComponent} from './components/delego-silent-payment/delego-silent-payment.component';
import {StoreModule} from '@ngrx/store';
import {GenericConfiguratorErrorModule} from '../product/configurator/error-handling/generic-configurator-error/generic-configurator-error.module';
import {I18nModule} from '@spartacus/core';
import {NetNewModule} from '../product/configurator/error-handling/net-new/net-new.module';
import {PAYMENT_AUTHORIZATION_FEATURE} from './services/store/payment-state';
import {EffectsModule} from '@ngrx/effects';
import {CardPaymentEffects} from '../cart/store/effects/card-payment.effect';
import * as fromDelego from './services/store/reducers/delego.reducer';
import * as fromStripe from './services/store/reducers/stripe.reducer';
import * as fromCyberSource from './services/store/reducers/cyber-source.reducer';
import {StripeEffects} from './services/store/effects/stripe.effects';
import {MockAddNewCcComponent} from './components/mock-cc-component/mock-add-new-cc.component';
import {ComboBoxDropdownModule, ComboBoxModule, CountrySelectorModule, InputModule} from 'ng-design-system';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CyberSourceAddNewCcComponent} from '@app/payment/components/cybersource/cyber-source-add-new-cc/cyber-source-add-new-cc.component';
import {ContentLoadingIndicatorModule} from '@app/shared/content-loading-indicator/content-loading-indicator.module';
import {CyberSourceEffects} from '@app/payment/services/store/effects/cyber-source.effects';
import {CyberSourceThreedsDialogComponent} from '@app/payment/components/cybersource/cyber-source-threeds-dialog/cyber-source-threeds-dialog.component';
import {CyberSourceDeviceDataCollectionFormComponent} from '@app/payment/components/cybersource/cyber-source-device-data-collection-form/cyber-source-device-data-collection-form.component';
import {CyberSourcePlaceOrderComponent} from '@app/payment/components/cybersource/cyber-source-place-order/cyber-source-place-order.component';

@NgModule({
  declarations: [
    DelegoSilentPaymentComponent,
    CyberSourceAddNewCcComponent,
    CyberSourceThreedsDialogComponent,
    CyberSourcePlaceOrderComponent,
    MockAddNewCcComponent,
    CyberSourceDeviceDataCollectionFormComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(PAYMENT_AUTHORIZATION_FEATURE, {
      delego: fromDelego.delegoReducer,
      stripe: fromStripe.stripeReducer,
      cyberSource: fromCyberSource.cyberSourceReducer,
    }),
    EffectsModule.forFeature([CardPaymentEffects]),
    EffectsModule.forFeature([StripeEffects, CyberSourceEffects]),
    GenericConfiguratorErrorModule,
    I18nModule,
    NetNewModule,
    ComboBoxDropdownModule,
    ComboBoxModule,
    CountrySelectorModule,
    InputModule,
    ReactiveFormsModule,
    ContentLoadingIndicatorModule,
    FormsModule,
  ],
  exports: [
    DelegoSilentPaymentComponent,
    CyberSourceAddNewCcComponent,
    CyberSourceThreedsDialogComponent,
    MockAddNewCcComponent,
    CyberSourceDeviceDataCollectionFormComponent,
    CyberSourcePlaceOrderComponent,
  ]
})
export class PaymentModule {
}
